import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import { TRANSFER_POLL_INTERVAL } from '../constants';
import type { Transfer } from '../types';

export function useTransfer(operationId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.transfers.detail(operationId ?? ''),
    queryFn: () => apiClient.get<Transfer>(`/transfers/${operationId}`),
    enabled: !!operationId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === 'running' || status === 'queued') return TRANSFER_POLL_INTERVAL;
      return false;
    },
  });
}
